import store from '@/store/index'
import getUserAccessData from '@/services/userAccessData/getUserAccessData.service'
import getUserAccessPermissionsData from '@/services/userAccessData/getUserAccessPermissionsData.service'
import { LogOutService } from '@/services/auth/common/logOutService'
import { $bus } from '@/main'

/**
 * Get user access data and dispatch the response on UsersAccess store
 */
export const loadUserAccess = async (name) => {
  store.dispatch('ui/showMask')
  getUserAccessData().then((result) => {
    if (result.status === 200) {
      if (result.data[0].userDetails?.isActive) {
        store.dispatch('UsersAccess/setUsersAccess', result.data)
        $bus.$emit('userAccessResponse', name)
        // store.dispatch('ui/hideMask')
      } else {
        LogOutService.logoutApp()
      }
    } else {
      store.dispatch('UsersAccess/setUsersAccess', [])
      store.dispatch('ui/hideMask')
    }
  }).catch(error => {
    console.log(error)
    LogOutService.logoutApp()
  })
}

/**
 *
 * @returns list of country for specified user
 */
export const countryUsersAccess = () => {
  const usersAccessData = store.getters['UsersAccess/UsersAccess']
  const countryList = []
  if (usersAccessData?.length) {
    usersAccessData[0].countryAccessInfo.map((item) => {
      countryList.push(item.countryData)
    })
    return countryList
  }
}

/**
 *
 * @returns list of supplier for selected country
 */
export const supplierUsersAccess = () => {
  const usersAccessData = store.getters['UsersAccess/UsersAccess']
  const supplierList = []
  if (usersAccessData?.length) {
    usersAccessData[0].countryAccessInfo.map((item) => {
      item.supplierData.map((supData) => {
        supplierList.push(supData)
      })
    })
    if (supplierList?.length > 0) {
      supplierList.sort((a, b) => a?.supplierName?.toUpperCase() > b?.supplierName?.toUpperCase() ? 1 : -1)
    }
    return supplierList
  }
}

/**
 *
 * @returns list of warehouse for selected country
 */
export const wareHouseUsersAccess = () => {
  const usersAccessData = store.getters['UsersAccess/UsersAccess']
  const warehouseList = []
  if (usersAccessData?.length) {
    usersAccessData[0].countryAccessInfo.map((item) => {
      item.warehouseData.map((wrhData) => {
        warehouseList.push(wrhData)
      })
    })
    return warehouseList
  }
}

/**
 *
 * @returns list of all anomalyType
 */
export const anomalyTypeUsersAccess = () => {
  const usersAccessData = store.getters['UsersAccess/UsersAccess']
  const anomalyTypeList = []
  if (usersAccessData?.length) {
    usersAccessData[0].countryAccessInfo.map((item) => {
      item.anomalyTypeData.map((anmtData) => {
        anomalyTypeList.push(anmtData)
      })
    })
    return anomalyTypeList
  }
}

export const qualifiersUsersAccess = () => {
  const usersAccessData = store.getters['UsersAccess/UsersAccess']
  const qualifiersList = []
  if (usersAccessData?.length) {
    usersAccessData[0].countryAccessInfo.map((item) => {
      item.qualifiers.map((anmtData) => {
        qualifiersList.push(anmtData)
      })
    })
    return qualifiersList
  }
}
/**
 *
 * @returns user access details
 */
export const usersDetails = () => {
  const userDetailsData = store.getters['UsersAccess/UsersAccess']
  if (userDetailsData?.length) {
    return userDetailsData[0].userDetails
  }
}

export const loadUserAccessPermissions = async () => {
  store.dispatch('ui/showMask')
  getUserAccessPermissionsData().then((result) => {
    if (result.status === 200) {
      store.dispatch('UsersAccess/setUsersAccessPermissions', result.data)
      $bus.$emit('userAccessPermissionsResponse')
      // store.dispatch('ui/hideMask')
    } else {
      store.dispatch('UsersAccess/setUsersAccessPermissions', [])
      store.dispatch('ui/hideMask')
    }
  })
}

export const userPermissions = () => {
  const userAccessPermissionData = store.getters['UsersAccess/UsersAccessPermissions']
  if (userAccessPermissionData?.length) {
    return userAccessPermissionData[0].menuAccess
  }
}

/**
 *
 * @returns france sector details
 */
export const franceSectorList = () => {
  const franceSectorData = store.getters['UsersAccess/FranceSectorList']
  return franceSectorData?.length > 0 ? franceSectorData : []
}
